import { FC } from "react";
import Button from "components/Button";

interface PrevNextPaginationProps {
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

const PrevNextPagination: FC<PrevNextPaginationProps> = ({
  currentPage,
  hasNextPage,
  hasPrevPage,
  onPageChange,
  disabled,
}) => (
  <div className="flex items-center justify-between mt-4">
    <Button
      text="Previous"
      size="SM"
      className="button button-secondary"
      disabled={!hasPrevPage || disabled}
      onClick={() => onPageChange(currentPage - 1)}
    />

    <span className="text-sm text-neutral-600">
      Page {currentPage}
    </span>

    <Button
      text="Next"
      size="SM"
      className="button button-secondary"
      disabled={!hasNextPage || disabled}
      onClick={() => onPageChange(currentPage + 1)}
    />
  </div>
);

export default PrevNextPagination;
